import type { WorkTranslation } from "./en.work";

const workRu: WorkTranslation = {
  apps: {
    title: "Приложения",
    intro: "У каждого приложения свои версии. Версия может появиться вручную, из тега git или из деплоя.",
    empty: "Приложений пока нет. Добавьте приложение, чтобы отслеживать его версии.",
    add: "Добавить приложение",
    edit: "Изменить приложение",
    name: "Название",
    required: "Обязательно",
    platformsLabel: "Платформы",
    platformsRequired: "Выберите хотя бы одну платформу",
    platforms: { android: "Android", ios: "iOS", desktop: "Десктоп", web: "Веб", backend: "Бэкенд" },
    source: "Откуда берутся версии",
    sources: { manual: "Вручную", tag: "Теги git", deployment: "Деплои" },
    sourceHints: {
      manual: "Версии добавляют вручную.",
      tag: "Тег с префиксом и номером версии создаёт эту версию.",
      deployment: "Деплой в окружение, который добавляет влитые изменения, создаёт версию.",
    },
    sourceHintEdit: "Изменение влияет только на новые версии.",
    repo: "Репозиторий",
    pickRepo: "Выберите репозиторий",
    removedRepoOption: "{{path}} (убран из этого проекта)",
    noRepos: "В этом проекте пока нет репозиториев, поэтому этот источник недоступен.",
    openGitlab: "Открыть настройки GitLab",
    tagPrefix: "Префикс тега",
    tagPrefixHint: "Например, v или android/. Оставьте пустым, если тег состоит только из номера версии.",
    tagMeansReleased: "Тег означает, что версия выпущена",
    tagReleases: "Тег отмечает версию как выпущенную.",
    tagNotReleases: "Тег не отмечает версию как выпущенную.",
    tagPattern: "теги {{prefix}}*",
    environment: "Продакшен-окружение",
    environmentHint: "Выберите окружение из репозиториев проекта или введите название. Оно должно совпадать точно.",
    sharedPrefix: "Этот репозиторий и префикс тега используются также в {{apps}}, поэтому содержимое будет одинаковым.",
    sharedEnvironment: "Этот репозиторий и окружение используются также в {{apps}}, поэтому содержимое будет одинаковым.",
    versionCount_one: "{{count}} версия",
    versionCount_few: "{{count}} версии",
    versionCount_many: "{{count}} версий",
    versionCount_other: "{{count}} версии",
    needsSorting: "Нужно разобрать",
    needsSortingHint: "При обновлении не удалось определить, к какому приложению относятся эти версии. Проверьте их и отметьте приложение как разобранное.",
    markSorted: "Отметить как разобранное",
    noPlatforms: "Выберите платформы этого приложения. При обновлении их не удалось определить.",
    repoRemoved: "Этот репозиторий убран из проекта, поэтому приложение ничего из него не получает. Добавьте репозиторий снова или выберите другой.",
    archived: "В архиве",
    archive: "В архив",
    unarchive: "Вернуть из архива",
    archiveTitle: "Отправить {{name}} в архив?",
    archiveBody: "Приложение перестанет следить за GitLab и исчезнет из списков выбора. Его версии останутся, и о багах на них по-прежнему можно сообщать.",
    archivedToast: "Приложение в архиве",
    unarchived: "Приложение возвращено из архива",
    deleteTitle: "Удалить {{name}}?",
    deleteBody: "У него нет версий и появлений багов, поэтому больше ничего не потеряется.",
    merge: "Объединить с другим приложением",
    mergeTitle: "Объединить {{name}} с другим приложением?",
    mergeBody: "Выбранное приложение получит все его версии, появления багов, отметки о регрессии, тест-кейсы и задания GitLab в очереди, а также платформы. Версии с одинаковым именем станут одной. {{name}} исчезнет, и это нельзя отменить.",
    mergeInto: "Объединить с",
    mergeConfirm: "Объединить приложения",
    merged: "Приложения объединены",
    deleted: "Приложение удалено",
    created: "Приложение добавлено",
    saved: "Приложение сохранено",
    ignoredTags_one: "{{count}} пропущенный тег",
    ignoredTags_few: "{{count}} пропущенных тега",
    ignoredTags_many: "{{count}} пропущенных тегов",
    ignoredTags_other: "{{count}} пропущенного тега",
    ignoredReason: {
      empty: "после префикса нет версии",
      not_semver: "не версия SemVer, например 2.4.0 или 2.4.0-rc.1",
      too_long: "версия длиннее 80 символов",
    },
  },
  gitlab: {
    chip: {
      failed_pipeline: "Пайплайн упал",
      failed_pipelineMany: "Пайплайн упал · MR: {{count}}",
      changed_since_tested: "Изменено после теста",
      changed_since_testedMany: "Изменено после теста · MR: {{count}}",
      running_pipeline: "Пайплайн идёт",
      running_pipelineMany: "Пайплайн идёт · MR: {{count}}",
      draft: "MR-черновик",
      draftMany: "Черновик · MR: {{count}}",
      open: "MR открыт",
      openMany: "Открыт · MR: {{count}}",
      merged: "MR влит",
      mergedMany: "Влит · MR: {{count}}",
      deployed: "Развёрнуто",
      deployedMany: "Развёрнуто · MR: {{count}}",
      branch_only: "Ветка",
      branch_onlyMany: "Веток: {{count}}",
    },
    chipHint: {
      failed_pipeline: "Упал пайплайн в связанном merge request.",
      changed_since_tested: "После последнего завершённого раунда появились новые коммиты. Результаты раунда и статус задачи не меняются.",
      running_pipeline: "В связанном merge request идёт пайплайн.",
      draft: "Связанный merge request ещё черновик.",
      open: "Связанный merge request открыт.",
      merged: "Связанный merge request влит, но ещё не развёрнут.",
      deployed: "Связанное изменение влито и развёрнуто.",
      branch_only: "Связана ветка, merge request пока нет.",
      mrs: "Merge request: {{count}}.",
      branches: "Веток: {{count}}.",
      moreBranches: "Других веток: {{count}}.",
      environments: "Окружения: {{environments}}.",
      disconnected: "GitLab отключён, данные могли устареть.",
    },
    pipeline: {
      created: "Пайплайн создан",
      waiting_for_resource: "Пайплайн ждёт",
      preparing: "Пайплайн готовится",
      pending: "Пайплайн в очереди",
      running: "Пайплайн идёт",
      success: "Пайплайн прошёл",
      failed: "Пайплайн упал",
      canceling: "Пайплайн отменяется",
      canceled: "Пайплайн отменён",
      skipped: "Пайплайн пропущен",
      manual: "Пайплайн ждёт ручного шага",
      scheduled: "Пайплайн запланирован",
      lastKnown: "Последнее известное: {{status}}",
    },
    mrState: { opened: "Открыт", merged: "Влит", closed: "Закрыт", locked: "Заблокирован" },
    draft: "Черновик",
    source: {
      branch: "Найдено в названии ветки",
      title: "Найдено в заголовке MR",
      description: "Найдено в описании MR",
      manual: "Добавлено вручную",
    },
    mergeRequests: "Merge request",
    branches: "Ветки",
    environments: "Окружения",
    disconnected: "GitLab отключён. Здесь то, что Mixla видела в последний раз ({{time}}). Ссылки нельзя добавлять, пока менеджер платформы не подключит его снова.",
    disconnectedNever: "GitLab отключён. Ссылки нельзя добавлять, пока менеджер платформы не подключит его снова.",
    changedNotice: "После последнего завершённого раунда появились новые коммиты. Результаты раунда и статус задачи не меняются, а повторный тест запросите вы или включённое правило.",
    waiting: "Ожидает перехода в {{status}}: {{blockers}}",
    blockerEnvironment: "{{mr}} ещё не в {{environment}}",
    blockerMerge: "{{mr}} ещё не влит",
    emptyTitle: "Код пока не связан",
    emptyBody: "Запушьте ветку с таким названием или укажите ключ задачи в заголовке merge request, и связь появится сама. Более ранняя работа появится, когда GitLab сообщит о новой активности в ней.",
    copyBranch: "Скопировать название ветки",
    branchForNewWork: "Название ветки для новой работы",
    addLink: "Связать merge request или ветку",
    addLinkPlaceholder: "Вставьте ссылку из GitLab",
    addLinkButton: "Добавить ссылку",
    addLinkHint: "Она должна вести в репозиторий, подключённый к этому проекту.",
    linkAdded: "Ссылка добавлена",
    lastSynced: "Синхронизировано {{time}}",
    bugEmptyTitle: "Код пока не связан",
    bugEmptyBody: "Отправьте ветку с этим именем или укажите ключ бага в заголовке merge request'а, и связь появится сама.",
    bugUnconfirmed: "Только упомянуто в описании. Не считается выпуском исправления и не влияет на отметку бага исправленным, пока кто-нибудь не подтвердит.",
    unconfirmed: "Только упомянуто в описании. Не учитывается в правилах, комментариях о раундах и на карточке, пока кто-нибудь не подтвердит.",
    confirmLink: "Подтвердить связь",
    linkConfirmed: "Связь подтверждена",
    removeLink: "Убрать связь",
    removeTitle: "Убрать связь с {{name}}?",
    removeBody: "Она не вернётся, даже когда GitLab сообщит о новой активности. Добавить её снова можно вручную.",
    linkRemoved: "Связь убрана",
  },
  testStageDetail: {
    round: "раунд {{n}}",
    failed_one: "{{count}} провал",
    failed_few: "{{count}} провала",
    failed: "{{count}} провалов",
  },
  doneGuard: {
    title: "Перевести непроверенную работу в «Готово»?",
    one: "{{key}} не прошла тестирование. Она будет отмечена как «не проверено».",
    many_one: "{{keys}} не прошла тестирование ({{count}} из {{total}}). Она будет отмечена как «не проверено».",
    many_few: "{{keys}} не прошли тестирование ({{count}} из {{total}}). Они будут отмечены как «не проверено».",
    many: "{{keys}} не прошли тестирование ({{count}} из {{total}}). Они будут отмечены как «не проверено».",
    confirm: "Перевести в «Готово»",
  },
  testStage: {
    not_started: "Не тестировалась",
    ready_for_test: "Готова к тестированию",
    in_testing: "Тестируется",
    changes_requested: "Нужны исправления",
    ready_for_retest: "Готова к повторной проверке",
    passed: "Прошла",
  },
  poker: {
    nav: "Покер планирования",
    title: "Покер планирования",
    start: "Покер планирования",
    banner: "Идёт покер планирования — ведёт {{name}} (готово {{done}} / {{total}})",
    join: "Присоединиться",
    noneTitle: "Покер планирования не идёт",
    noneBody: "Начните его из спринта на странице бэклога: команда вместе оценит неоценённые задачи спринта.",
    present_one: "{{count}} участник",
    present_few: "{{count}} участника",
    present: "{{count}} участников",
    facilitator: "Ведущий: {{name}}",
    takeOver: "Стать ведущим",
    end: "Завершить",
    round: "Раунд {{n}}",
    yourVote: "Ваш голос",
    changeUntilReveal: "Его можно менять, пока голоса не открыты.",
    spread: "Разброс {{spread}}",
    nVotes_one: "{{count}} голос",
    nVotes_few: "{{count}} голоса",
    nVotes: "{{count}} голосов",
    noVotes: "нет голосов",
    agree: "Согласованная оценка:",
    reveal: "Открыть голоса",
    revote: "Голосовать заново",
    skip: "Пропустить",
    skipped: "пропущена",
    allDone: "По всем задачам есть решение",
    allDoneBody: "Выберите пропущенную в очереди или завершите сессию.",
    votes: "Голоса · {{voted}} из {{total}}",
    votedLabel: "{{name}} проголосовал(а)",
    notVotedLabel: "{{name}} ещё не голосовал(а)",
    queue: "Задачи · {{done}} / {{total}}",
    saidRevealed: "Голоса открыты",
    saidVoted: "Проголосовали {{n}} из {{total}}",
    saidFacilitator: "Теперь ведёт {{name}}",
  },
  templates: {
    saveAs: "Сохранить как шаблон",
    saveAsHint: "Название, описание, приоритет, теги, оценка, чек-листы (без отметок) и названия подзадач.",
    saved: "Шаблон сохранён",
    name: "Название шаблона",
    taskTitle: "Название задачи",
    fromTemplate: "Шаблон",
    blank: "Пустая задача",
    fromNamed: "Из «{{name}}»",
    titleHint: "Оставьте пустым, чтобы взять «{{title}}».",
    checklistFromTemplate: "Чек-лист из шаблона",
    taskTemplates: "Шаблоны задач",
    taskTemplatesIntro: "Задачи, которые вы создаёте снова и снова: название, описание, приоритет, оценка, чек-листы и подзадачи. Выбирается в «Новой задаче».",
    new: "Новый шаблон",
    edit: "Изменить шаблон",
    none: "Шаблонов пока нет. Создайте здесь или из меню ··· любой задачи.",
    nChecklists_one: "{{count}} чек-лист",
    nChecklists_few: "{{count}} чек-листа",
    nChecklists: "{{count}} чек-листов",
    nSubtasks_one: "{{count}} подзадача",
    nSubtasks_few: "{{count}} подзадачи",
    nSubtasks: "{{count}} подзадач",
    checklists: "Чек-листы",
    checklistsHint: "Один чек-лист на блок: название в первой строке, пункты ниже. Чек-листы разделяйте пустой строкой.",
    subtasks: "Подзадачи",
    subtasksHint: "По одному названию подзадачи в строке.",
    deleteTitle: "Удалить шаблон «{{name}}»?",
    deleteBody: "Задачи из него останутся. Повторы с этим шаблоном удалятся.",
    checklistTemplates: "Шаблоны чек-листов",
    checklistTemplatesIntro: "Чек-листы, которые добавляются к любой задаче одним щелчком.",
    newChecklist: "Новый шаблон чек-листа",
    editChecklist: "Изменить шаблон чек-листа",
    noneChecklists: "Шаблонов чек-листов пока нет.",
    items: "Пункты",
    itemsHint: "По одному пункту в строке.",
    nItems_one: "{{count}} пункт",
    nItems_few: "{{count}} пункта",
    nItems: "{{count}} пунктов",
    recurring: "Повторяющиеся задачи",
    recurringIntro: "Шаблон, который по расписанию становится задачей, в часовом поясе проекта. Повторяющиеся задачи в активном спринте не считаются его объёмом.",
    newRule: "Новая повторяющаяся задача",
    editRule: "Изменить повторяющуюся задачу",
    needTemplate: "Сначала создайте шаблон задачи.",
    noRules: "Повторяющихся задач пока нет.",
    template: "Шаблон",
    repeat: "Повтор",
    on: "В",
    onDays: "По этим дням",
    dayOfMonth: "День месяца",
    hour: "Час",
    atHour: "в {{hour}}:00",
    intoSprint: "в активный спринт",
    intoSprintLabel: "Класть в активный спринт (в бэклог, если активного нет)",
    skipIfOpen: "Пропускать, пока прошлая созданная задача открыта",
    ruleHint: "Время — в часовом поясе проекта (настройки спринтов).",
    pause: "Приостановить",
    resume: "Возобновить",
    paused: "Приостановлено",
    pausedBecause: "Приостановлено: {{reason}}",
    nextRun: "Следующая: {{when}}",
    lastTask: "последняя — {{key}}",
    rule: {
      daily: "Каждый день",
      dailyOn: "Каждый: {{days}}",
      weekly: "Каждую неделю: {{day}}",
      monthly: "Ежемесячно, {{day}}-го",
      kindDaily: "Ежедневно",
      kindWeekly: "Еженедельно",
      kindMonthly: "Ежемесячно",
    },
  },
  flow: {
    nav: "Поток",
    title: "Поток",
    period: "Период",
    lastDays: "Последние {{n}} дн.",
    days: "{{n}} дн.",
    historySince: "История статусов ведётся с {{date}}; более ранняя работа не измеряется.",
    notEnough: "Пока готовых задач с измеренным временем цикла: {{n}}. Процентили и отметка «зависло» появятся от {{min}}.",
    cycleMedian: "Время цикла (медиана)",
    p85: "85% — до {{v}}",
    leadMedian: "Время выполнения (медиана)",
    throughput: "Пропускная способность",
    perWeek: "{{n}} / нед.",
    completed_one: "{{count}} готова",
    completed_few: "{{count}} готовы",
    completed: "{{count}} готово",
    wip: "Сейчас в работе",
    wipHint: "Задачи в активном статусе",
    cfd: "Накопительный поток",
    cfdHint: "Задачи по группам статусов на конец каждого дня. Расширяющаяся середина — работа копится в процессе.",
    cat: { not_started: "Не начаты", active: "В работе", done: "Готовы" },
    aging: "Зависшие задачи",
    agingHint: "Открытые задачи по времени в текущем статусе. Отмечены те, что дольше {{v}} (85% готовой работы уложились быстрее).",
    agingHintNoData: "Открытые задачи по времени в текущем статусе.",
    overP85: "дольше обычного",
    noAging: "Ничего не в работе.",
  },
  standup: {
    nav: "Стендап",
    title: "Стендап",
    since: "с {{date}}",
    range: "Период",
    sinceLastDay: "С прошлого рабочего дня",
    lastWeek: "Последние 7 дней",
    scope: "Задачи",
    auto: "Активный спринт (или все)",
    sprintScope: "{{name}}",
    allTasks: "Все задачи проекта",
    blocked_one: "{{count}} задача заблокирована",
    blocked_few: "{{count}} задачи заблокированы",
    blocked: "{{count}} задач заблокировано",
    blockedBy: "ждёт {{keys}}",
    finished: "Готово",
    moved: "Перемещено",
    tested: "Проверено",
    round: "раунд {{n}}: прошло {{passed}}, упало {{failed}}",
    now: "Сейчас",
    emptyTitle: "Пока пусто",
    emptyBody: "Здесь появятся перемещения, комментарии, раунды тестирования и работа в процессе.",
  },
  epics: {
    nav: "Эпики",
    title: "Эпики",
    epic: "Эпик",
    new: "Новый эпик",
    edit: "Изменить эпик",
    name: "Название",
    description: "Описание",
    color: "Цвет",
    targetDate: "Целевая дата",
    target: "Цель — {{date}}",
    stateLabel: "Состояние эпика",
    state: { planned: "Запланирован", in_progress: "В работе", done: "Готов" },
    noEpic: "Без эпика",
    none: "Эпиков пока нет",
    change: "Сменить эпик",
    followsParent: "Подзадача в эпике своей задачи",
    noTasks: "Задач пока нет",
    progressTasks: "{{done}} / {{total}} задач",
    progressPts: "{{done}} / {{total}} очк.",
    doneEpics: "Готовые",
    emptyTitle: "Эпиков пока нет",
    emptyBody: "Эпик объединяет задачи из разных спринтов и показывает прогресс. Задача выбирает эпик так же, как спринт.",
    deleteTitle: "Удалить эпик «{{name}}»?",
    deleteBody: "Его задачи останутся — без эпика.",
    filter: "Эпик",
    nEpics_one: "{{count}} эпик",
    nEpics_few: "{{count}} эпика",
    nEpics: "{{count}} эпиков",
  },
  releases: {
    nav: "Релизы",
    title: "Релизы",
    release: "Релиз",
    new: "Новый релиз",
    name: "Название",
    nameHint: "SemVer, например 2.4.0 или 2.4.0-rc.1. Часть +build отбрасывается.",
    targetDate: "Целевая дата",
    state: { unreleased: "Не выпущен", released: "Выпущен", archived: "В архиве" },
    noRelease: "Без релиза",
    change: "Сменить релиз",
    releasedOn: "Выпущен {{date}}",
    targetOn: "Цель — {{date}}",
    noItems: "Пока пусто",
    itemsHint: "Выберите этот релиз в задачах (или массово) и в исправленных багах.",
    items: "Задачи {{tasks}} · баги {{bugs}}",
    progressLabel: "Готово и проверено: {{done}} из {{total}}",
    nDone_one: "{{count}} готова",
    nDone_few: "{{count}} готовы",
    nDone: "{{count}} готово",
    nNotVerified_one: "{{count}} готова, не проверена",
    nNotVerified_few: "{{count}} готовы, не проверены",
    nNotVerified: "{{count}} готово, не проверено",
    nOpen_one: "{{count}} открыта",
    nOpen_few: "{{count}} открыты",
    nOpen: "{{count}} открыто",
    nBugsFixed: "Исправлено багов: {{fixed}} / {{total}}",
    notes: "Заметки к релизу",
    notesGenerated: "собраны из задач",
    notesEdited: "изменены",
    notesFrozen: "зафиксированы при выпуске",
    notesEmpty: "Заметки появятся, когда задачи будут готовы, а баги исправлены.",
    editNotes: "Изменить заметки",
    regenerate: "Собрать заново",
    copyMarkdown: "Скопировать как Markdown",
    copied: "Заметки скопированы",
    markReleased: "Отметить выпущенным",
    markTitle: "Выпустить {{name}}?",
    freezeNote: "Заметки к релизу зафиксируются в текущем виде.",
    openItems_one: "{{count}} элемент ещё открыт.",
    openItems_few: "{{count}} элемента ещё открыты.",
    openItems: "{{count}} элементов ещё открыто.",
    moveTo: "Перенести открытые в",
    moveToNew: "Перенести в новый релиз",
    releaseAnyway: "Выпустить всё равно (они останутся, отмечены как не вошедшие)",
    released: "{{name}} выпущен",
    archive: "В архив",
    unarchive: "Из архива",
    deleteTitle: "Удалить релиз «{{name}}»?",
    deleteBody: "Его задачи и баги останутся — без него. Если есть появления багов, исправления или раунды тестирования, он будет отправлен в архив.",
    filter: "Релиз",
    fixRelease: "Версия исправления",
    app: "Приложение",
    allApps: "Все приложения",
    chooseApp: "Выберите приложение",
    showMore: "Показать ещё",
    noAppsTitle: "Приложений пока нет",
    noAppsBody: "Каждая версия относится к приложению, например Android или Backend. Добавьте первое.",
    noAppsAsk: "Каждая версия относится к приложению, например Android или Backend. Добавить его может менеджер проекта.",
    appEmpty: {
      manual: "Версий пока нет.",
      tag: "Версий пока нет. Они появятся, когда будет отправлен подходящий тег.",
      deployment: "Версий пока нет. Они появятся, когда деплой в прод добавит влитые изменения.",
    },
    nameError: {
      empty: "Укажите название версии.",
      not_semver: "Это не версия SemVer. Используйте вид 2.4.0 или 2.4.0-rc.1, без v в начале.",
      too_long: "Название длиннее 80 символов.",
    },
    olderHint: "Версии {{app}} создаются из деплоев, поэтому добавленная здесь версия — более старая, уже вышедшая.",
    olderManagerOnly: "Версии {{app}} создаются из деплоев. Добавить более старую вручную может только менеджер.",
    cameOut: "Дата выхода",
    cameOutMissing: "Выберите дату выхода.",
    editTarget: "Задать целевую дату",
    marker: {
      rolled_back: "Откачена",
      incomplete: "Состав может быть неполным",
      needs_merge: "То же название, что у другой версии",
      notes_frozen: "Заметки зафиксированы",
    },
    rolledBackShort: "откачена",
    rolledBackHint: "Откачена {{date}}. Её исправления не считаются, пока этот коммит или содержащий его не будет развёрнут снова.",
    incompleteHint: "Часть коммитов этой версии ещё не связана с merge request, поэтому некоторых элементов может не быть.",
    incompleteNote: "Некоторых элементов может не быть: {{note}}",
    needsMergeHint: "При обновлении в этом приложении нашлась другая версия с таким названием. Менеджер может объединить их.",
    notesFrozenHint: "Элементы, найденные позже, попадают в состав, но не в заметки.",
    fromTag: "Из тега {{tag}}",
    fromDeployment: "Из деплоя",
    group: {
      shipped: "Вышло",
      planned_not_shipped: "Запланировано, но не вышло",
      unplanned: "Вышло без плана",
    },
    groupEmpty: {
      shipped: "Пока ничего не вышло.",
      planned_not_shipped: "Ничего не ожидает: всё запланированное вышло.",
      unplanned: "Ничего не вышло без плана.",
    },
    listCapped: "Показаны первые {{listed}} задач из {{total}}.",
    pickSearch: "Поиск версий",
    noVersions: "Версий пока нет",
    noMatch: "Подходящих версий нет",
    otherSelected: "Другая выбранная версия",
    lock: {
      manager_only: "Уже выпущена: изменить может только менеджер",
      archived: "В архиве, изменить нельзя",
    },
    rename: "Переименовать",
    renameTitle: "Переименовать {{name}}",
    move: "Перенести в другое приложение",
    moveTitle: "Перенести {{name}}",
    moveHint: "Её состав, появления и флаги перейдут вместе с ней.",
    moveNoApps: "В этом проекте нет другого активного приложения.",
    moved: "{{name}} перенесена в {{app}}",
    merge: "Объединить с другой версией",
    mergeTitle: "Объединить {{name}}",
    mergePick: "Выберите версию, которая останется.",
    mergeConfirmTitle: "Объединить эти версии?",
    mergeConfirm: "Объединить в {{name}}",
    mergeBody: "Всё из {{from}} перейдёт в {{to}}, у которой останутся название и заметки. Ссылки на {{from}} будут открывать {{to}}. Это нельзя отменить.",
    merged: "Объединено в {{name}}",
    collisionTitle: "В {{app}} уже есть {{name}}",
    collisionBody: "Версию нельзя перенести в приложение, где уже есть такое название. Вместо этого можно объединить их.",
    nItems_one: "{{count}} элемент",
    nItems_few: "{{count}} элемента",
    nItems_many: "{{count}} элементов",
    nItems_other: "{{count}} элемента",
    nSightings_one: "{{count}} появление",
    nSightings_few: "{{count}} появления",
    nSightings_many: "{{count}} появлений",
    nSightings_other: "{{count}} появления",
    deletedArchived: "У {{name}} есть появления багов, исправления или раунды тестирования, поэтому она отправлена в архив",
  },
  views: {
    views: "Виды",
    mine: "Мои виды",
    shared: "Общие для проекта",
    none: "Сохранённых видов пока нет",
    saveAs: "Сохранить как вид…",
    update: "Обновить «{{name}}»",
    updated: "Вид обновлён",
    rename: "Переименовать вид",
    share: "Открыть для проекта",
    unshare: "Сделать личным",
    delete: "Удалить вид",
    leave: "Закрыть вид",
    moveUp: "Выше",
    moveDown: "Ниже",
    unsaved: "Есть несохранённые изменения",
    name: "Название",
    shareWithProject: "Открыть всем в проекте",
    hint: "Вид запоминает фильтры, представление, группировку и сортировку.",
    deleteTitle: "Удалить вид «{{name}}»?",
    deleteBody: "Задачи останутся как есть.",
    deleteSharedBody: "Он пропадёт у всех в проекте. Задачи останутся как есть.",
    staleFilters: "Некоторых фильтров этого вида больше нет — они пропущены.",
  },
  shortcuts: {
    assignedToYou: "Назначено на вас",
    title: "Горячие клавиши",
    status: "Сменить статус",
    assignees: "Сменить исполнителей",
    assignMe: "Назначить на себя",
    priority: "Сменить приоритет",
    estimate: "Сменить оценку",
    due: "Сменить срок",
    tags: "Добавить или убрать теги",
    sprint: "Перенести в спринт",
    comment: "Написать комментарий",
    nextPrev: "Следующая / предыдущая задача списка",
    close: "Закрыть",
    help: "Показать этот список",
    enabled: "Клавиши из одной буквы",
    enabledHint: "Отключите, если они мешают экранному диктору или голосовому управлению. J, K и Esc продолжат работать.",
  },
  bulk: {
    bar: "Выбранные задачи",
    nSelected: "Выбрано: {{count}}",
    working: "Применяем…",
    clear: "Снять выбор",
    add: "Добавить",
    remove: "Убрать",
    only: "Только",
    updated_one: "Обновлена {{count}} задача",
    updated_few: "Обновлены {{count}} задачи",
    updated: "Обновлено {{count}} задач",
    failed: "Ничего не изменилось. {{message}}",
    deleteTitle_one: "Удалить {{count}} задачу?",
    deleteTitle_few: "Удалить {{count}} задачи?",
    deleteTitle: "Удалить {{count}} задач?",
    deleteBody: "Их подзадачи удалятся вместе с ними. Это нельзя отменить.",
    oneProjectOnly: "Статус, исполнители и спринт — только для задач одного проекта",
    select: "Выбрать {{key}}",
    selectAll: "Выбрать все показанные",
    failedRow: "Не изменена",
  },
  work: {
    fieldFilter: "Поле",
    chooseField: "Выберите поле",
    clearFieldFilter: "Сбросить фильтр по полю",
    fieldContains: "Содержит…",
    fieldCompare: "Сравнение",
    after: "После",
    before: "До",
    fieldIsSet: "Заполнено",
    fieldIsEmpty: "Не заполнено",
    yes: "Да",
    no: "Нет",
    properties: "Свойства",
    createdBy: "Создал(а) {{name}} · {{date}}",
    descriptionHint: "@ — упомянуть. Сохраняется, когда вы уходите из поля · Esc — отменить · ⌘/Ctrl+Enter — сохранить сразу.",
    editDescription: "Изменить описание",
    saving: "Сохраняем…",
    saved: "Сохранено",
    subtask: "Подзадача",
    checklist: "Чек-лист",
    link: "Связь",
    file: "Файл",
    prevTask: "Предыдущая задача",
    nextTask: "Следующая задача",
    nOfTotal: "{{n}} из {{total}}",
    openPage: "Открыть страницей",
    myWork: "Мои задачи",
    myWorkIntro: "Открытые задачи, назначенные вам, во всех проектах.",
    allTasks: "Все задачи",
    allTasksIntro: "Задачи во всех проектах, которые вам доступны.",
    newTaskShortcut: "Новая задача (C)",
    search: "Поиск по ключу или названию",
    view: "Вид",
    views: { list: "Список", board: "Доска", table: "Таблица", calendar: "Календарь" },
    status: "Статус",
    nStatuses: "Статусы: {{count}}",
    assignees: "Исполнители",
    nPeople: "Людей: {{count}}",
    assignedToMe: "Назначены мне",
    mine: "Мои",
    tags: "Метки",
    nTags: "Метки: {{count}}",
    project: "Проект",
    due: "Срок",
    anyDue: "Любой срок",
    dueThisWeek: "Срок в течение недели",
    dueAt: "Дата и время срока",
    groupBy: "Группировка",
    group: { status: "По статусу", assignee: "По исполнителю", due: "По сроку", priority: "По приоритету", project: "По проекту", none: "Без группировки" },
    sort: "Сортировка",
    sorts: { manual: "Ручной порядок", due: "Срок", priority: "Приоритет", created: "Новые", updated: "Недавно изменённые", title: "Название", key: "Ключ" },
    showClosed: "Закрытые",
    showSubtasks: "Подзадачи",
    clearFilters: "Сбросить фильтры",
    emptyTitle: "Задач пока нет",
    emptyBody: "Создайте первую задачу. Задачи, загруженные Claude через CLI, тоже появятся здесь.",
    emptyAll: "Здесь пока пусто.",
    noMatch: "Нет подходящих задач.",
    noTasksHere: "Нет задач",
    capped: "Показаны первые 500 задач. Уточните фильтры, чтобы увидеть остальные.",
    addTask: "Добавить задачу",
    addTaskTo: "Добавить задачу в «{{status}}»",
    addTaskOn: "Добавить задачу со сроком {{date}}",
    unassigned: "Не назначена",
    noValue: "Без значения",
    nobody: "Никто",
    category: { not_started: "К выполнению", active: "В работе", done: "Готово", closed: "Закрыто" },
    priority: "Приоритет",
    priorities: { urgent: "Срочный", high: "Высокий", medium: "Средний", low: "Низкий", none: "Без приоритета" },
    priorityIs: "Приоритет: {{priority}}",
    changePriority: "Приоритет: {{priority}}. Изменить",
    nPriorities: "Приоритеты: {{count}}",
    dueBucket: { overdue: "Просрочены", today: "Сегодня", tomorrow: "Завтра", week: "На этой неделе", later: "Позже", none: "Без срока" },
    today: "Сегодня",
    tomorrow: "Завтра",
    yesterday: "Вчера",
    inAWeek: "Через неделю",
    clearDue: "Без срока",
    noDue: "Без срока",
    changeStatus: "Статус: {{status}}. Изменить",
    changeAssignees: "Изменить исполнителей",
    changeDue: "Изменить срок",
    changeTester: "Изменить тестировщика",
    searchPeople: "Найти человека",
    searchTags: "Найти или создать метку",
    createTag: "Создать «{{name}}»",
    noTags: "Меток пока нет",
    newTag: "Новая метка",
    tagName: "Название метки",
    addTag: "Добавить метку",
    removeTag: "Убрать метку {{name}}",
    tagsAdmin: "Метки",
    tagsIntro: "Метки общие для всех проектов. Создать метку может любой, кто редактирует задачи; удалённая метка снимается со всех задач.",
    deleteTagTitle: "Удалить метку «{{name}}»?",
    deleteTagBody: "Она будет снята со всех задач. В истории каждой задачи останется, что она там была.",
    tester: "Тестировщик",
    anyTester: "Любой тестировщик проекта",
    created: "Создана",
    updated: "Изменена",
    key: "Ключ",
    description: "Описание",
    addDescription: "Описания пока нет.",
    writeDescription: "Написать описание",
    markdownMentions: "Введите @, чтобы упомянуть человека.",
    mentionSomeone: "Упомянуть человека",
    subtasks: "Подзадачи",
    subtasksDone: "Готово подзадач: {{done}} из {{total}}",
    addSubtask: "Добавить подзадачу",
    checklists: "Чек-листы",
    checklistDone: "Выполнено пунктов: {{done}} из {{total}}",
    addChecklist: "Чек-лист",
    checklistName: "Название чек-листа",
    noChecklists: "Чек-листов нет.",
    addItem: "Добавить пункт…",
    deleteChecklist: "Удалить чек-лист",
    deleteChecklistTitle: "Удалить «{{name}}»?",
    deleteChecklistBody: "Чек-лист и все его пункты будут удалены.",
    files: "Файлы",
    addFile: "Добавить файл",
    noFiles: "Файлов нет.",
    removeFile: "Удалить {{name}}",
    links: "Связи",
    addLink: "Связать задачу",
    noLinks: "Связанных задач нет.",
    findTask: "Найти задачу по ключу или названию",
    rel: { blocked_by: "Блокируется", blocks: "Блокирует", relates_to: "Связана с" },
    blocksLabel: "Блокирует",
    blockedByLabel: "Блокируется",
    relatesTo: "Связана с",
    blockedBy: "Блокируется открытыми задачами: {{count}}",
    blockedNotice: "Блокируется открытыми задачами ({{count}}):",
    comments: "Комментариев: {{count}}",
    fields: "Поля",
    testing: "Тестирование",
    copyLink: "Скопировать ссылку",
    linkCopied: "Ссылка скопирована",
    changeParent: "Изменить родительскую задачу",
    parentTitle: "Родитель для {{key}}",
    currentParent: "Родитель",
    makeTopLevel: "Сделать верхнего уровня",
    moveProject: "Перенести в другой проект",
    moveTitle: "Перенести {{key}}",
    moveHint: "В новом проекте у задачи будет новый ключ. Тест-кейсы, раунды и комментарии переносятся; значения пользовательских полей — нет.",
    move: "Перенести",
    moved: "Перенесена: теперь {{key}}",
    firstStatus: "Первый статус проекта",
    deleteTask: "Удалить задачу",
    deleteTitle: "Удалить {{key}}?",
    deleteBody: "Задача исчезнет из списков, её ключ перестанет работать. История сохраняется.",
    deleteBodySubtasks: "Задача и её подзадачи ({{count}}) исчезнут из списков. История сохраняется.",
    deleted: "{{key}} удалена",
    createAnother: "Создать ещё",
    prevMonth: "Предыдущий месяц",
    nextMonth: "Следующий месяц",
    nMore: "ещё {{count}}",
    allDated: "У всех задач есть срок.",
    dragToDate: "Перетащите задачу на день, чтобы назначить срок.",
  },
  thread: {
    nChanges: "Изменений: {{count}}",
    nChangesBy: "{{actor}}: изменений — {{count}}",
    collapseChanges: "Свернуть",
    hidePanel: "Скрыть комментарии",
    title: "Комментарии",
    showChanges: "Изменения",
    empty: "Комментариев пока нет. Начните обсуждение.",
    older: "Показать ранние",
    new: "Новые",
    system: "Mixla",
    none: "нет",
    noDate: "без даты",
    deleted: "Комментарий удалён",
    edited: "изменён",
    editComment: "Изменить комментарий",
    delete: "Удалить",
    deleteTitle: "Удалить комментарий?",
    deleteBody: "Все увидят, что комментарий удалён. Его файлы больше нельзя будет открыть.",
    hide: "Скрыть для меня",
    placeholder: "Напишите комментарий… @ — упомянуть",
    hint: "⌘/Ctrl+Enter — отправить · вставьте или перетащите файлы",
    attach: "Прикрепить файлы",
    send: "Отправить",
    tooLarge: "{{name}} больше 100 МБ",
    readOnly: "Наблюдатели могут читать комментарии, но не писать.",
    event: {
      changed: "{{actor}} изменил(а) задачу",
      created: "{{actor}} создал(а) задачу",
      status_changed: "{{actor}} перевёл(а) из «{{from}}» в «{{to}}»",
      due_changed: "{{actor}} изменил(а) срок: {{from}} → {{to}}",
      priority_changed: "{{actor}} изменил(а) приоритет: {{from}} → {{to}}",
      title_changed: "{{actor}} переименовал(а) (было «{{from}}»)",
      assignee_added: "{{actor}} назначил(а) {{user}}",
      assignee_removed: "{{actor}} снял(а) {{user}}",
      tester_changed: "{{actor}} сменил(а) тестировщика: {{from}} → {{to}}",
      parent_changed: "{{actor}} сменил(а) родителя: {{from}} → {{to}}",
      epic_changed: "{{actor}} сменил(а) эпик: {{from}} → {{to}}",
      release_changed: "{{actor}} сменил(а) релиз: {{from}} → {{to}}",
      release_added: "{{actor}} добавил(а) это в {{to}}",
      release_removed: "{{actor}} убрал(а) это из {{from}}",
      tag_added: "{{actor}} добавил(а) метку {{tag}}",
      tag_removed: "{{actor}} убрал(а) метку {{tag}}",
      attachment_added: "{{actor}} прикрепил(а) {{file}}",
      attachment_removed: "{{actor}} удалил(а) {{file}}",
      moved_out: "{{actor}} перенёс(ла) в другой проект: {{from_key}} → {{to_key}}",
      moved_in: "{{actor}} перенёс(ла) сюда: {{from_key}} → {{to_key}}",
      deleted: "{{actor}} удалил(а) задачу",
    },
  },
  testingBoard: {
    nav: "Тестирование",
    title: "Доска тестирования",
    intro: "Задачи по стадиям тестирования. Перетащите карточку из «На тест» в «Тестируется» или нажмите «Начать», чтобы начать раунд.",
    project: "Проект",
    allProjects: "Все проекты",
    nothing: "Сейчас нечего тестировать. Задачи появляются здесь, когда разработчик переводит их в колонку тестирования.",
    columns: { to_test: "На тест", testing: "Тестируется", waiting: "У разработчика", passed: "Прошли в спринте" },
    empty: {
      to_test: "Ничего не ждёт теста.",
      testing: "Нет активных раундов.",
      waiting: "Ничего не вернулось разработчикам.",
      passed: "В этом спринте пока ничего не прошло.",
    },
    passedMore: "Показаны последние {{count}}.",
    cases_one: "{{count}} кейс",
    cases_few: "{{count}} кейса",
    cases: "{{count}} кейсов",
    start: "Начать раунд",
    startTitle: "Тестирование {{key}}",
    noCases: "У задачи пока нет тест-кейсов.",
    writeCases: "Добавьте их в задаче",
    nothingToRetest: "С прошлого раунда ничего не изменилось и не упало: выберите все кейсы.",
  },
  workSettings: {
    testingFlow: "Колонка тестирования",
    testingFlowIntro: "Перевод задачи в этот статус запрашивает у тестировщиков тест (или повторный тест). Если вывести её оттуда до начала тестирования, запрос отменяется. Раунд, где прошли все кейсы, сам переводит задачу дальше; после проваленного раунда она остаётся на месте.",
    testingStatus: "Статус тестирования",
    testingNone: "Нет — статусы не трогают тестирование",
    onPass: "Когда раунд пройден, перевести в",
    onPassNext: "Следующий статус ({{name}})",
    onPassStay: "Оставить (нет следующего статуса)",
    testingSaved: "Колонка тестирования сохранена",
    wip: "WIP",
    wipHint: "Колонка доски предупреждает, когда задач больше лимита. Перемещения не блокируются.",
    wipFor: "Лимит WIP для «{{name}}»",
    colorFor: "Цвет статуса «{{name}}»",
    colorDefault: "Цвет категории",
    colors: { gray: "Серый", blue: "Синий", indigo: "Индиго", purple: "Фиолетовый", pink: "Розовый", red: "Красный", orange: "Оранжевый", amber: "Янтарный", green: "Зелёный", teal: "Бирюзовый" },
    overLimit: "сверх лимита",
    wipWarning: "В «{{name}}» больше задач, чем лимит WIP ({{limit}})",
    statuses: "Статусы задач",
    statusesIntro: "Этапы, через которые проходит задача, по порядку. Категория определяет, что считается открытым или завершённым; в проекте всегда есть хотя бы один статус «Готово».",
    newStatus: "Новый статус",
    category: "Категория",
    nTasks: "Задач: {{count}}",
    deleteStatus: "Удалить статус «{{name}}»?",
    deleteStatusBody: "Ни одна задача его не использует.",
    moveTasks: "Этот статус у задач: {{count}}. Перенести их в:",
    moveTo: "Перенести задачи в",
    fields: "Пользовательские поля",
    fieldsIntro: "Дополнительные свойства задач проекта. Видны в задаче, в таблице и в фильтрах.",
    addField: "Добавить поле",
    editField: "Изменить поле",
    fieldName: "Название",
    fieldType: "Тип",
    typeFixed: "Тип поля изменить нельзя.",
    type: { text: "Текст", number: "Число", date: "Дата", checkbox: "Флажок", single_select: "Выбор из списка", user: "Человек" },
    options: "Варианты",
    addOption: "Добавить вариант",
    color: "Цвет",
    optionRemoveHint: "Удалённый вариант очищается у задач, где он был выбран.",
    deleteField: "Удалить поле «{{name}}»?",
    deleteFieldBody: "Поле и его значения у всех задач будут удалены.",
  },
};

export default workRu;
